<template>
  <el-dialog
    title="详情"
    :visible.sync="handOverDialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    append-to-body
    :before-close="handleClose"
    :modal-append-to-body="false"
  >
    <div class="carDetailBox" v-loading="loading">
      <div class="header-img">
        <div class="img">
          <el-image
            fit="fit"
            style="flex-shrink: 1; flex-grow: 1"
            :src="data.inImage"
            z-index="5000"
            :preview-src-list="[data.inImage || carImg]"
          >
            <div slot="error" class="image-slot">
              <img src="./car.png" width="100%" alt="" />
            </div>
          </el-image>
          <div style="width: 20px; margin-left: 15px; font-size: 20px">入场照片</div>
        </div>
        <div class="img" style="border-left: 1px solid #eee">
          <div style="width: 20px; margin-right: 15px; font-size: 20px">出场照片</div>
          <el-image
            style="flex-shrink: 1; flex-grow: 1"
            z-index="5000"
            :src="data.outImage"
            :preview-src-list="[data.outImage || carImg]"
          >
            <div slot="error" class="image-slot">
              <img src="./car.png" width="100%" alt="" />
            </div>
          </el-image>
        </div>
      </div>
      <el-row style="margin: 10px 20px">
        <el-col span="8"> 车牌号码: {{ data.plateNumber }} </el-col>
        <el-col span="8"> 车辆类型: {{ data.carType }} </el-col>
        <el-col span="8"> 套餐名称: {{ data.setmealName }} </el-col>
      </el-row>
      <el-row style="margin: 10px 20px">
        <el-col span="8"> 入场通道: {{ data.inPassageName }} </el-col>
        <el-col span="8"> 出场通道: {{ data.outPassageName }} </el-col>
        <el-col span="8"> 开闸方式: {{ data.openTypeStr }} </el-col>
      </el-row>
      <el-row style="margin: 10px 20px">
        <el-col span="8"> 入场时间: {{ data.inTime }} </el-col>
        <el-col span="8"> 出场时间: {{ data.outTime }} </el-col>
        <el-col span="8"> 停车时长: {{ data.parkingTime }} </el-col>
      </el-row>
      <el-row style="margin: 10px 20px">
        <el-col span="8"> 应收金额: {{ data.chargeTotal }} </el-col>
        <el-col span="8"> 优惠金额: {{ data.discountAmount }} </el-col>
        <el-col span="8"> 实收金额: {{ data.chargeAmount }} </el-col>
      </el-row>
      <el-row style="margin: 10px 20px">
        <el-col span="8"> 付款方式: {{ data.payType }} </el-col>
        <el-col span="8"> 付款时间: {{ data.payTime }} </el-col>
        <el-col span="8"> 备注信息: {{ data.remark }} </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
import { inoroutDetails } from '@/api/v4ward/carv2/carinoutinfo';
export default {
  data() {
    return {
      data: {
        inImage: './car.png',
        outImage: './car.png',
      },
      loading: false,
      show: true,
      handOverDialogVisible: false,
      carImg: require('./car.png'),
    };
  },
  methods: {
    openDialog(data, type) {
      this.loading = true;
      if (type == 'in') {
        this.inoroutDetails(data.id);
      } else if (type == 'out') {
        this.inoroutDetails(data.inId, data.id);
      }
      this.handOverDialogVisible = true;
    },
    inoroutDetails(id,id2) {
      inoroutDetails({ inId: id, outId:id2 })
        .then(({ data }) => {
          this.data = data;
          this.show = false;
          this.loading = false;
        })
        .catch((err) => {
          this.show = false;
          this.loading = false;
        });
    },
    handleClose(done) {
      if (done) {
        done();
      }

      this.data = {
        inImage: this.carImg,
        outImage: this.carImg,
      };
      this.handOverDialogVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.carDetailBox {
  .header-img {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .img {
      width: 50%;
      padding: 10px 20px;
      justify-content: space-between;
      flex-shrink: 1;
      flex-grow: 1;
      display: flex;
      align-items: center;
    }
  }
}
</style>
